import {z} from 'zod'

import {apiFetch} from 'src/api/fetch'

import {
    type CreateEquipmentYardInput,
    createEquipmentYardRequestSchema,
    type EquipmentYard,
    equipmentYardSchema,
    type UpdateEquipmentYardInput,
    updateEquipmentYardRequestSchema,
} from './schemas'

export async function listActiveEquipmentYards(): Promise<EquipmentYard[]> {
    const raw = await apiFetch<unknown>('/settings/yards')
    return z.array(equipmentYardSchema).parse(raw)
}

export async function listAllEquipmentYards(): Promise<EquipmentYard[]> {
    const raw = await apiFetch<unknown>('/settings/yards/all')
    return z.array(equipmentYardSchema).parse(raw)
}

export async function createEquipmentYard(input: CreateEquipmentYardInput): Promise<EquipmentYard> {
    const raw = await apiFetch<unknown>('/settings/yards', {
        method: 'POST',
        body: JSON.stringify(createEquipmentYardRequestSchema.parse(input)),
    })
    return equipmentYardSchema.parse(raw)
}

export async function updateEquipmentYard(
    id: string,
    input: UpdateEquipmentYardInput,
): Promise<EquipmentYard> {
    const raw = await apiFetch<unknown>(`/settings/yards/${id}`, {
        method: 'PATCH',
        body: JSON.stringify(updateEquipmentYardRequestSchema.parse(input)),
    })
    return equipmentYardSchema.parse(raw)
}
